import React from 'react';
import { Badge, Icons, SvgIconProps, SxProps } from '@/theme/index';
import { StyledBox } from '../components';

interface ConditionalBadgeProps {
  showBadge?: boolean;
  recordedItem?: boolean;
  customBoxBackgroundColor?: string;
  customBadgeIconColor?: string;
  icon: React.ComponentType<SvgIconProps & { sx?: SxProps }>;
}

export const ConditionalBadge = ({
  showBadge = true,
  recordedItem,
  customBoxBackgroundColor,
  customBadgeIconColor,
  icon: Icon,
}: ConditionalBadgeProps) => {
  let boxBackgroundColor = 'barChart.dark';
  let badgeIconColor = 'lineChart.light';

  if (showBadge) {
    if (customBoxBackgroundColor && customBadgeIconColor) {
      boxBackgroundColor = customBoxBackgroundColor;
      badgeIconColor = customBadgeIconColor;
    } else if (recordedItem) {
      boxBackgroundColor = '#FBEEEF';
      badgeIconColor = 'error.main';
    } else {
      boxBackgroundColor = '#E6ECE6';
      badgeIconColor = 'listingPins.light';
    }
  }

  const BadgeIcon = recordedItem
    ? Icons.ErrorRounded
    : Icons.CheckCircleRounded;
  const content = (
    <StyledBox sx={{ backgroundColor: boxBackgroundColor }}>
      <Icon
        data-testid="conditional-badge-icon"
        className={`${!recordedItem && showBadge && 'unrecorded-item'}`}
        sx={{ color: badgeIconColor }}
      />
    </StyledBox>
  );

  return showBadge ? (
    <Badge
      data-testid="conditional-badge"
      badgeContent={
        <BadgeIcon
          className={`${!recordedItem && 'unrecorded-item'}`}
          fontSize="small"
          sx={{ color: badgeIconColor }}
        />
      }
      sx={{ '& .MuiBadge-badge': { top: 5 } }}
    >
      {content}
    </Badge>
  ) : (
    content
  );
};
